import Reflux from 'reflux';

const AuditLogLicenseActions = Reflux.createActions({
  getLicenseStatus: { asyncResult: true },
});

export default AuditLogLicenseActions;
